import { usePermissions } from '@/shared/permissions';

import { CATALOG_PERMISSIONS } from '../model/permissions';

export interface CatalogPermissions {
  /** Browse the catalog (products, categories, media, import, search). */
  canView: boolean;
  /** Create/edit catalog data. */
  canManage: boolean;
  /** Read price governance (config, rules, approvals, policy, audit). */
  canPricingView: boolean;
  /** Manage price governance. */
  canPricingManage: boolean;
}

/** Resolves the four catalog permission flags from the session permissions. */
export function useCatalogPermissions(): CatalogPermissions {
  const { hasPermission } = usePermissions();
  return {
    canView: hasPermission(CATALOG_PERMISSIONS.catalog.view),
    canManage: hasPermission(CATALOG_PERMISSIONS.catalog.manage),
    canPricingView: hasPermission(CATALOG_PERMISSIONS.pricing.view),
    canPricingManage: hasPermission(CATALOG_PERMISSIONS.pricing.manage),
  };
}
